/**
 * A collection of browser-safe data conversion utilities to replace Node.js's Buffer.
 */

/**
 * Creates a Uint8Array from various data types, mimicking `Buffer.from()`.
 * This is a safe alternative that uses browser-native APIs.
 * @param data - The data to convert. Can be a string, an array of bytes, or an ArrayBuffer.
 * @param encoding - The encoding for string data (currently only 'utf-8' is supported).
 * @returns Uint8Array
 */
export function from(data: any, encoding: string = 'utf-8'): Uint8Array {
    if (typeof data === 'string') {
        // TextEncoder is the modern, browser-safe way to convert strings to bytes.
        const encoder = new TextEncoder();
        return encoder.encode(data);
    }

    // If the data is already an array of numbers (like from a JSON response) or an ArrayBuffer,
    // we can convert it directly to a Uint8Array.
    if (Array.isArray(data) || data instanceof ArrayBuffer) {
        return new Uint8Array(data);
    }

    // If it's already a Uint8Array, just return it.
    if (data instanceof Uint8Array) {
        return data;
    }

    throw new Error('Unsupported data type for conversion. Please provide a string, array, or ArrayBuffer.');
}
